import type { LoanProduct } from "../../prisma/generated"

export const STATE_CODES = [
  `AK`,
  `AL`,
  `AR`,
  `AZ`,
  `CA`,
  `CO`,
  `CT`,
  `DC`,
  `DE`,
  `FL`,
  `GA`,
  `HI`,
  `IA`,
  `ID`,
  `IL`,
  `IN`,
  `KS`,
  `KY`,
  `LA`,
  `MA`,
  `MD`,
  `ME`,
  `MI`,
  `MN`,
  `MO`,
  `MS`,
  `MT`,
  `NC`,
  `ND`,
  `NE`,
  `NH`,
  `NJ`,
  `NM`,
  `NV`,
  `NY`,
  `OH`,
  `OK`,
  `OR`,
  `PA`,
  `PR`,
  `RI`,
  `SC`,
  `SD`,
  `TN`,
  `TX`,
  `UT`,
  `VA`,
  `VT`,
  `WA`,
  `WI`,
  `WV`,
  `WY`,
] as const

export function canActivate(loanProduct: LoanProduct): boolean {
  return (
    loanProduct &&
    !!loanProduct.providerFee &&
    loanProduct.providerFee > 0 &&
    loanProduct.statesActive.length > 0 &&
    loanProduct.statesPossible.length > 0
  )
}

export function cannotActivateReason(loanProduct: LoanProduct): string {
  if (!loanProduct) {
    return `No loan product`
  }
  if (!loanProduct.providerFee) {
    return `No provider fee`
  }
  if (loanProduct.providerFee <= 0) {
    return `Provider fee is not greater than zero`
  }
  if (loanProduct.statesActive.length === 0) {
    return `No active states`
  }
  if (loanProduct.statesPossible.length === 0) {
    return `No possible states`
  }

  return `unknown error`
}

export enum DisplayStatus {
  ConditionallyApproved = `Approved with Stipulations`,
  Approved = `Approved`,
  Denied = `Declined`,
  Pending = `Pending`,
  DocumentsSent = `Documents Sent`,
}
